/**
 * kokoroSingleton.js — Module-level singleton for KokoroTTSService.
 *
 * Ensures that VoiceSettings and FaanaVoiceService share ONE KokoroTTSService
 * instance, preventing dual model downloads (one per consumer).
 *
 * Usage:
 *   import { getKokoroTTSService } from './kokoroSingleton';
 *   const kokoro = getKokoroTTSService();
 *   kokoro.init((progress) => console.log(progress));
 */

import { KokoroTTSService } from './KokoroTTSService';

/** @type {KokoroTTSService|null} */
let _instance = null;

/**
 * Return the shared KokoroTTSService instance, creating it on first call.
 * Subsequent calls return the same instance (lazy singleton).
 *
 * @returns {KokoroTTSService}
 */
export function getKokoroTTSService() {
  if (!_instance) {
    _instance = new KokoroTTSService();
  }
  return _instance;
}
